import dictMixin from '@/mixins/dict-mixin'
const getDictItemName = dictMixin.methods.getDictItemName

import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      fieldKey: 'itemTextEn'
    }
  },
  computed: {
    ...mapGetters('language', ['languageStorage']),
  },
  watch: {
    languageStorage: {
      handler(lang) {
        console.log("lang",lang)
        if (lang == 'es') {
          this.fieldKey = 'itemTextEs'
        } else {
          this.fieldKey = 'itemTextEn'
        }
      },
      immediate: true,
    }
  },
  created() {
    this.getDict()
  },
  methods: {
    getDictItemName(type, value) {
      return getDictItemName.call(this, type, value, this.fieldKey)
    }
  },
}